<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t('message.conditions')"
    filterable
    clearable
 
  >
    <el-option v-for="item in injuryStatuses" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['status_id'],
  mounted() {
    if (this.injuryStatuses && this.injuryStatuses.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    status_id:{
       handler: function (val, oldVal) { 
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    }
  },
  computed: {
    ...mapGetters({
      injuryStatuses: 'injuryStatuses/inventory',
    }),
  },
  methods: {
    ...mapActions({
      getInventory: 'injuryStatuses/inventory',
    })
  },
};
</script>
